// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"607":"458070e3","770":"b0caadcb"}[chunkId] + ".chunk.css";
};